import React, { useEffect, useRef, useState, useLocation } from 'react';
import EditPartnerView from '../../views/AdminView/EditPartnerViews';
import EditPartnerDetails from '../../views/AdminView/EditPartnerDetails';
import { useParams } from 'react-router-dom';
import {usePartnerContext} from '../../components/Context/PartnerContext';

const EditPartnerComponent = () => {
    const {id, edit} = useParams();
    const didFetch = useRef(false);
    const [loading, setLoading] = useState(true);

    const {partner, FetchEditPartner} = usePartnerContext();
 
    const fetchData = async () => {
        try {
        
            await FetchEditPartner(id);
           
           
            setLoading(false);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    useEffect(() => {
        if (!didFetch.current) {
            fetchData();
            
            didFetch.current = true;
        }
    });
    
    return (
    <div>
     {/*{loading && <div>Loading...</div>}*/}
     {!loading  &&  edit == "false" && partner!=null && <EditPartnerDetails />}
     {!loading  &&  edit == "true" && partner!=null && <EditPartnerView  />}
    </div>
    );
   
};

export default EditPartnerComponent;
